<template>
  <div style="padding: 40px 16px 80px; min-height: calc( 100vh - 380px); position: relative;">
    <!-- 登錄註冊卡片 -->
    <div style="max-width: 480px; margin: 0 auto; background: #F6F8FB; border-radius: 12px; padding: 32px 24px;">
      <!-- 選項卡 -->
      <div style="display: flex; gap: 24px; margin-bottom: 32px;">
        <div v-for="(tab, index) in tabs" :key="index" @click="activeTab = index" :style="{
          fontSize: '18px',
          fontWeight: '600',
          color: activeTab === index ? '#3E4F7A' : '#999',
          cursor: 'pointer',
          borderBottom: activeTab === index ? '2px solid #3E4F7A' : 'none',
          paddingBottom: '6px'
        }">
          {{ tab }}
        </div>
      </div>

      <!-- 表單區域 -->
      <div>
        <div style="display: flex; flex-direction: column; gap: 20px;">
          <div>
            <label style="display: block; color: #3E4F7A; margin-bottom: 8px;">郵箱</label>
            <input v-model="form.username" type="text" style="
                width: 100%;
                padding: 12px;
                border: 1px solid #eee;
                border-radius: 6px;
                outline: none;
                &:focus { border-color: #3E4F7A; }
              " placeholder="請輸入郵箱">
          </div>

          <div>
            <label style="display: block; color: #3E4F7A; margin-bottom: 8px;">密碼</label>
            <input v-model="form.password" type="password" style="
                width: 100%;
                padding: 12px;
                border: 1px solid #eee;
                border-radius: 6px;
                outline: none;
                &:focus { border-color: #3E4F7A; }
              " placeholder="請輸入密碼">
          </div>

          <button style="
              width: 100%;
              background: #3E4F7A;
              color: white;
              padding: 14px;
              border: none;
              border-radius: 6px;
              font-weight: 600;
              cursor: pointer;
              margin-top: 12px;
            " @click="SubmitEvent()">

            {{ activeTab === 0 ? '立即登錄' : '立即註冊' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 版權聲明 -->
    <div style="
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-top: 1px solid #eee;
      background: #fafafa;
      text-align: center;
      padding: 20px 0;
    ">
      <div style="color: #999; font-size: 12px; line-height: 1.8;">
        <div>Copyright © 2018-2025 碼雲 版權所有</div>
        <div style="margin-top: 4px;">
          <span>技術驅動商業進化</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';

export default {
  data() {
    return {
      tabs: ['登錄', '註冊'],
      activeTab: 0,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    SubmitEvent() {

      if (this.form.username.length === 0) {
        Message.error({
          message: "請填寫郵箱"
        })
        return
      }

      // 新增郵箱格式驗證
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailRegex.test(this.form.username.trim())) {
        Message.error({
          message: "請輸入有效的郵箱地址"
        })
        return
      }

      if (this.form.password.length === 0) {
        Message.error({
          message: "請填寫密碼"
        })
        return
      }


      switch (this.activeTab) {
        case 0:
          this.$axios.post("/api/user/login", {
            email: this.form.username,
            password: this.form.password,
          }).then((res) => {
            if (res.data.status == 0) {
              localStorage.setItem("selTopMenuIndex", 'shop')
              Message.success({
                message: `妳好，${res.data.data}!`
              })
              location.reload()
            }
          })
          break
        case 1:
          this.$axios.post("/api/user/register", {
            email: this.form.username,
            password: this.form.password,
            from: localStorage.getItem('PROXY_FROM')
          }).then((res) => {
            if (res.data.status == 0) {
              this.form = {}
              this.activeTab = 0
              Message.success({
                message: `妳好，${res.data.data}!`
              })
            }
          })
          break
      }
    }
  }
}
</script>
